import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { LoadingWrapper } from './StructureLocationPageWrapper.styles';
import { Loader, LoaderColorProps } from '../../../components/atoms/Loader';
import { AddEditStructureLocation } from './AddEditStructureLocation';
import { ClientCustomerAddEditStructure } from './ClientCustomerAddEditStructure';
import { useGetCurrentUserVisibility } from '../../../queries/visibilityRules-query';
import { AddEditStructureLocationWrapperProps } from './AddEditStructureLocationWrapper.props';

export const AddEditStructureLocationWrapper: React.FC<AddEditStructureLocationWrapperProps> = ({ 
  isConfigPage,
  pageType,
  structureId,
  locationType,
  locationText,
  mainLocationNode,
  defaultClientId,
  defaultContractId,
  defaultBrandId,
  setMainLocationNode,
  setSubLocationNode,
  setLocationText,
  setOpenLocationCreateUpdatePopup,
  onSetCreatedLocation
}) => {
  const location = useLocation();
  const getCurrentUserVisibility = useGetCurrentUserVisibility();

  useEffect(() => {
    getCurrentUserVisibility.refetch();
  }, []);

  return (
    (getCurrentUserVisibility?.isLoading || !getCurrentUserVisibility?.data ?
      <LoadingWrapper>
        <Loader color={LoaderColorProps.Primary} />
      </LoadingWrapper> 
      :
      (getCurrentUserVisibility?.data?.hasClientCustomer && !isConfigPage ?
        <ClientCustomerAddEditStructure 
          key={location.pathname}
          pageType={pageType}
          structureId={structureId}
          locationType={locationType}
          locationText={locationText}
          mainLocationNode={mainLocationNode}
          defaultClientId={defaultClientId}
          defaultContractId={defaultContractId}
          defaultBrandId={defaultBrandId}
          onSetCreatedLocation={onSetCreatedLocation}
          setMainLocationNode={setMainLocationNode}
          setSubLocationNode={setSubLocationNode}
          setLocationText={setLocationText}
          setOpenLocationCreateUpdatePopup={setOpenLocationCreateUpdatePopup}
        />
        :
        <AddEditStructureLocation
          key={location.pathname}
          pageType={pageType}
          structureId={structureId}
          locationType={locationType}
          locationText={locationText}
          mainLocationNode={mainLocationNode}
          onSetCreatedLocation={onSetCreatedLocation}
          setMainLocationNode={setMainLocationNode}
          setSubLocationNode={setSubLocationNode}
          setLocationText={setLocationText}
          setOpenLocationCreateUpdatePopup={setOpenLocationCreateUpdatePopup}
        />
      )
    )
  );
};